import React from "react";
import classNames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useSnapshot } from "valtio";
import {
    AngleSmallLeftIcon,
    AngleSmallRightIcon,
    StyledIconButton,
} from "@aureskonnect/react-ui";

import { capitalize } from "@helpers/general";

import "swiper/swiper-bundle.css";

import { setSelectedLanguage, store } from "../../../Website/CoverPage/store";
import { languages } from "@constants/template";

export function SwiperLanguagesWrapper({ section }: any): JSX.Element {
    const { selectedLanguage } = useSnapshot(store);

    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    return (
        <div>
            {languages.length < 5 ? (
                <div
                    className="d-flex flex-row justify-content-center align-items-center"
                    style={{
                        width: "95%",
                        height: "36px !important",
                        gap: "10px",
                        marginLeft: "20px",
                        marginBottom: "2px",
                        marginTop: "2px",
                    }}
                >
                    {languages.map((language, index) => {
                        return (
                            <div
                                key={index}
                                className={classNames(
                                    "width__clz border-white rounded",
                                    {
                                        "slide-color__clz":
                                            language.key === selectedLanguage,
                                    }
                                )}
                                style={{
                                    width: "100%",
                                }}
                                onClick={() => {
                                    setSelectedLanguage(language.key);
                                }}
                            >
                                {capitalize(language.label)}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: "95%", marginLeft: "13px" }}
                >
                    <StyledIconButton
                        ref={navigationPrevRef}
                        className="m-0 p-0 swiper-button__clz"
                    >
                        <AngleSmallLeftIcon
                            height={50}
                            width={40}
                            fill="#323332"
                        />
                    </StyledIconButton>
                    <Swiper
                        className="design-ways-swiper-wrapper__clz"
                        modules={[Navigation]}
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                        }}
                        spaceBetween={14}
                        slidesPerView={4}
                    >
                        {languages.map((item, index) => {
                            return (
                                <SwiperSlide
                                    className={classNames(
                                        "width__clz border-white rounded",
                                        {
                                            "slide-color__clz":
                                                selectedLanguage === item.key,
                                        }
                                    )}
                                    key={index}
                                    onClick={() => {
                                        setSelectedLanguage(item.key);
                                    }}
                                >
                                    <span
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        {capitalize(item.label)}
                                    </span>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <StyledIconButton
                        ref={navigationNextRef}
                        className="m-0 p-0 swiper-button__clz"
                    >
                        <AngleSmallRightIcon
                            height={50}
                            width={40}
                            fill="#323332"
                        />
                    </StyledIconButton>
                </div>
            )}
        </div>
    );
}
